import { isEmail } from '../../../../utils/validation';
export function viewStateEmailSelector(state) {
  var viewData = state.view.data;
  if (viewData && viewData.email) {
    return viewData.email;
  } else if (state.login && isEmail(state.login)) {
    return state.login;
  }
  return '';
}
export function restoreErrorSelector(state) {
  return state.authentication.restore.error;
}
export function restoreStatusSelector(state) {
  return state.authentication.restore.status;
}